import { render, staticRenderFns } from "./ChildView.vue?vue&type=template&id=f3a784c0&lang=pug&"
import script from "./ChildView.vue?vue&type=script&lang=js&"
export * from "./ChildView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports